module.exports = {
    baseUrl: 'https://om.store.i-ktv.com',
    UpUrl:'https://obs.ccea.i-ktv.com'
}

